<template>
  <v-container>
    <v-row justify="center">
      <v-col v-if="showApproveDealButton" cols="12" sm="6">
        <v-btn
          block
          depressed
          color="success"
          @click="approveDeal"
        >
          Approve Deal
        </v-btn>
      </v-col>
      <v-col v-if="showRejectDealButton" cols="12" sm="6">
        <v-btn
          block
          depressed
          color="warning"
          @click="rejectDeal"
        >
          Reject Deal
        </v-btn>
      </v-col>
      <v-col v-if="showCreateDealButton" cols="12" sm="6">
        <v-btn
          block
          depressed
          color="primary"
          :disabled="!isFormValid"
          @click="createNewDeal"
        >
          {{ createNewDealButtonLabel }}
        </v-btn>
      </v-col>
      <v-col cols="12" sm="6">
        <v-btn
          block
          outlined
          depressed
          @click="cancel"
        >
          {{ cancelButtonLabel }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
export default {
  props: {
    showCreateDealButton: {
      type: Boolean,
      default: true
    },
    showApproveDealButton: {
      type: Boolean,
      default: false
    },
    showRejectDealButton: {
      type: Boolean,
      default: false
    },
    isFormValid: {
      type: Boolean,
      default: false
    },
    createNewDealButtonLabel: {
      type: String,
      default: 'Continue'
    },
    cancelButtonLabel: {
      type: String,
      default: 'Cancel'
    }
  },
  methods: {
    approveDeal () {
      this.$emit('approveDeal')
    },
    rejectDeal () {
      this.$emit('rejectDeal')
    },
    createNewDeal () {
      this.$emit('createNewDeal')
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>
